const ORDER_LOOKUP_FAILED_ATTEMPTS_MSG = 'We’re still unable to find your order. For help, please call us at 1-800-289-6229.';
const ORDER_LOOKUP_FAILED_KEY = 'orderLookupAttempts';
const ATTEMPTS_COUNT = 4;

const isOrderLookupFailedAttempts = () => {
  const orderLookupAttempts = JSON.parse(localStorage.getItem(ORDER_LOOKUP_FAILED_KEY));
  if (orderLookupAttempts?.date) {
    const timerEnded = new Date(orderLookupAttempts.date).getTime() <= new Date().getTime();
    const count = orderLookupAttempts.count;
    if (count >= ATTEMPTS_COUNT && !timerEnded) {
      return true;
    }
  }
  return false;
};

const setIsOrderLookupAttemptsFailed = () => {
  const orderLookupAttempts = JSON.parse(localStorage.getItem(ORDER_LOOKUP_FAILED_KEY));
  let count = orderLookupAttempts ? orderLookupAttempts.count : 0;
  count += 1;
  const date = new Date();
  if (count >= ATTEMPTS_COUNT) {
    const timerEnded = new Date(orderLookupAttempts.date).getTime() + 30 * 60 * 1000 <= new Date().getTime();
    if (timerEnded) {
      localStorage.removeItem(ORDER_LOOKUP_FAILED_KEY);
      return;
    }
    date.setTime(date.getTime() + 30 * 60 * 1000);
    localStorage.setItem(ORDER_LOOKUP_FAILED_KEY, JSON.stringify({ count, date })); // set to 30 min from now
    return;
  }
  localStorage.setItem(ORDER_LOOKUP_FAILED_KEY, JSON.stringify({ count, date })); // set to current time
};

export const clearOrderLookupAttemptsFailed = () => localStorage.removeItem(ORDER_LOOKUP_FAILED_KEY);

export const orderLookupFailedAttemptsConfig = {
  ORDER_LOOKUP_FAILED_ATTEMPTS_MSG,
  ORDER_LOOKUP_FAILED_KEY,
  isOrderLookupFailedAttempts,
  setIsOrderLookupAttemptsFailed,
  clearOrderLookupAttemptsFailed,
};
